import React, {useEffect, useMemo, useState} from 'react';
import {EmptyBoxIcon, SortDownIcon, SortUpIcon} from '../../icons/Icons';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import LoadingSkeleton from './LoadingSkeleton';
import StateBasedPagination from './StateBasedPagination';

function BootStrapPagedTable({
    bordered,small,
    columns, per_page,
    loading,
    dataSource,
    onRowClick,
 }) {
    const [currentPage, setCurrentPage] = useState(0)
    const [sortColumnKey, updateSortColumnKey] = useState('')
    const [sortDirection, setSortDirection] = useState(1)
    const [limit, setLimit] = useState(per_page);
    useEffect(()=>{
        if(per_page) {
            setLimit(per_page)
        }
    },[per_page])
    const setSortColumnKey = (s) => () => {
        if (sortColumnKey === s) {
            setSortDirection((d)=>d === 1 ? 0 :1)
        } else {
            updateSortColumnKey(s)
            setSortDirection(1)
        }
    }
    const data = useMemo(()=>{
        if (sortColumnKey) {
            const sorter = columns.find((item) => (item.key || item.dataIndex) === sortColumnKey).sorter;
            if(sortDirection === 0){
                return dataSource.sort(sorter).revers()
            }else{
                return dataSource.sort(sorter);
            }
        }else{
            return dataSource
        }
    },[dataSource, sortColumnKey, sortDirection])


    return (
        <div className={'table-responsive'}>
            <table
                className={`table table-striped vertical-align ${bordered ? 'table-bordered' : ''} ${small ? 'table-sm' : ''}`}>
                <thead>
                <tr>
                    {
                        columns.map((item, index) => {
                            let sortIcon = null;
                            if (item.sorter) {
                                if ((item.key || item.dataIndex) === sortColumnKey) {
                                    //      console.log('comparing', item, sortColumnKey);
                                    sortIcon = <RenderSortDirectionIcon sortDirection={sortDirection}/>;
                                } else {
                                    sortIcon = null;
                                }
                            }
                            const onClick = item.sorter ? setSortColumnKey(item.key || item.dataIndex) : null;
                            let thCls = onClick ? ' table-sortable ' : null;
                            thCls += sortIcon ? ' table-sortable-active' : '';
                            thCls += item.type === 'number' ? ' text-right' : '';
                            return (<th onClick={onClick} className={thCls} key={String(item.key || item.dataIndex || index)}>
                                <div className={'row align-items-center no-gutters'}>

                                    <div className={'col'}>{sortIcon}
                                        {
                                            typeof item.title === "string" ?
                                                <FormattedMessage id={item.title}/>
                                                : item.title
                                        }</div>
                                </div>
                            </th>);
                        })
                    }
                </tr>
                </thead>
                <tbody>

                {data.length === 0 && !loading ? <RenderEmptyBox columns={columns}/> : null}
                {data.length === 0 && loading ? <tr>
                    <td colSpan={columns.length} className={'my-4 py-4 text-center'}>
                        <LoadingSkeleton height={36.5}/>
                    </td>
                </tr> : null}
                {
                    data.slice(currentPage * limit, currentPage * limit + limit).map((item, index) =>
                        //  console.log(item);
                        <RenderRow onRowClick={onRowClick} key={String(item.key || item.dataIndex || index)}
                                   item={item} columns={columns}/>
                    )
                }
                </tbody>
            </table>
            {
                limit < data.length ? <div className={'d-flex justify-content-end mb-2'}>
                        <StateBasedPagination
                            count={data.length}
                            limit={limit}
                            page={currentPage}
                            goToPage={setCurrentPage}
                            setLimit={setLimit}
                        />
                    </div>
                    : null
            }
        </div>
    );
}

function RenderEmptyBox({columns}) {
    return (<tr>
        <td colSpan={columns.length}>
            <div className={'text-center'}>
                <EmptyBoxIcon className={'display-3 text-muted'}/>
                <p><FormattedMessage id={"No Data"}/></p>
            </div>
        </td>
    </tr>);
}

function RenderSortDirectionIcon({sortDirection}) {
    return sortDirection === 1 ? <SortUpIcon style={{width: '24px', height: '24px'}}/> :
        <SortDownIcon style={{width: '24px', height: '24px'}}/>;
}

function RenderRow({columns, item, onRowClick}) {
    let cls = onRowClick ? 'clickableRow' : '';
    return (
        <tr onClick={onRowClick ? onRowClick(item) : undefined} className={cls}>
            {
                columns.map((col, index) => {
                    if (col.render) {
                        return <td key={`${index}-${item.key}`}
                                   className={col.type === 'number' ? 'text-right' : ''}>{col.render(item[col.dataIndex], item)}</td>;
                    }
                    return <td key={`${index}-${item.key}`}
                               className={col.type === 'number' ? 'text-right' : ''}>{item[col.dataIndex]}</td>;

                })
            }
        </tr>
    );
}

BootStrapPagedTable.defaultProps = {
    per_page: 10
};

BootStrapPagedTable.propTypes = {
    per_page: PropTypes.number,
    dataSource: PropTypes.any.isRequired,
    columns: PropTypes.any.isRequired,
    bordered: PropTypes.bool,
    striped: PropTypes.bool,
    small: PropTypes.bool,
    loading: PropTypes.bool,

};

export default BootStrapPagedTable;
